<template>
  <v-container fluid class="gl-ledger-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Ledger</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="4">
                      <v-form>
                        <p class="text-h5">New Ledger</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_glledger.ledgercode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Ledger Code"
                          persistent-hint
                          single-line hint="Enter the ledger code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_glledger.ledgername"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Ledger Name"
                          persistent-hint
                          single-line hint="Enter the ledger name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Ledger', 'Other Ledger']"
                          v-model="new_glledger.ledgertype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the ledger type">
                        </v-select>
                        <v-switch
                          color="primary"
                          v-model="new_glledger.isTaxable"
                          v-bind:value="new_glledger ? new_glledger.isTaxable : false"
                          hint="Include Only Taxable"
                          persistent-hint
                        ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="4">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/gl-ledger/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertGLLedger()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      new_glledger: {},
      error: undefined,
      haserror: false,
      errorindex: undefined,
      accountsubclass1: null,
      accountsubclass2: null,
      classes: ['Current Asset', 'Current Liability', 'Sales Income', 'Service Income', 'Cost of Goods Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead', 'Payroll'],

    }
  },

  methods: {
    ...mapActions('GLLedger', ['insertGLLedgerRequest','getGLLedgersRequest']),
    checkError(){
      if(!this.new_glledger.ledgercode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_glledger.ledgername){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_glledger.ledgertype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertGLLedger() {
      await this.insertGLLedgerRequest(this.new_glledger)
      router.push('/gl-ledger/list')
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLLedger', ['isReceiving']),
  },
  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
